module.exports = __webpack_public_path__ + "static/img/banner003.35a5e33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner003.jpg
// module id = 7xn8
// module chunks = 15